import axiosLib from 'axios'
import { isRequestCancelled } from '@/utils/cancelableRequest'

const axiosAuth = axiosLib.create()

export function setToken(data) {
    localStorage.setItem('token', data)
}

export function setAccount(data) {
    localStorage.setItem('account', data)
}

export function setCurrency(data) {
    localStorage.setItem('currency', data)
}

export function setUserId(data) {
    localStorage.setItem('user_id', data)
}

export function setLang(data) {
    localStorage.setItem('lang', data)
}

export function getToken() {
    return localStorage.getItem('token')
}

export function getCurrency() {
    return localStorage.getItem('currency')
}

export function getUserId() {
    return localStorage.getItem('user_id')
}

export function getAccount() {
    return localStorage.getItem('account')
}

export function deleteToken() {
    localStorage.removeItem('token')
}

export function deleteAccount() {
    localStorage.removeItem('account')
}

export function deleteUserId() {
    localStorage.removeItem('user_id')
}

export function deleteCurrency() {
    localStorage.removeItem('currency')
}

export function setDataLanguage(data) {
    localStorage.setItem('dataLanguage', data)
}

export function getDataLanguage() {
    return localStorage.getItem('dataLanguage')
}

export function deleteDataLanguage() {
    return localStorage.removeItem('dataLanguage')
}

export function setLanguage(data) {
    localStorage.setItem('lang', data)
}

export function getLanguage() {
    return localStorage.getItem('lang')
}

axiosAuth.interceptors.request.use((request) => {
    request.headers['Content-Type'] = 'application/json'

    return request
})

axiosAuth.interceptors.response.use(
    (response) => {
        return Promise.resolve(response)
    },
    (error) => {
        if (isRequestCancelled(error)) {
            return Promise.reject(error)
        }
        if (error.response && error.response.data) {
            return Promise.reject(error.response.data)
        }
        return Promise.reject(error.message)
    }
)

export default axiosAuth
